<template>
  <div class="module">
    <div v-if="source===2"  class="message-box primary" @click="moduleToRouter('/index/chat/index')">
      在线客服
    </div>
    <el-tooltip class="item" effect="dark" content="下载中心" placement="bottom-start">
      <div  class="message-box" @click="moduleToRouter('/index/report/list')">
        <i class="el-icon-download"></i>
      </div>
    </el-tooltip>
    <div class="user-box">
      <user-avatar class="mr10" :width="30" :font-size="18" :height="30"></user-avatar>
      <div class="user-info" @mouseover="show = true" @mouseleave="show = false">
        {{user.nickName}}
        <transition name="el-zoom-in-top">
          <div class="user-info-menu" v-show="show">
            <ul>
              <li @click="showUpdatePass = true">修改密码</li>
            </ul>
          </div>
        </transition>
      </div>
      <span @click="outLogin" class="exit">退出</span>
    </div>

    <update-user-info v-model="showUpdate" ref="updateUserInfo"></update-user-info>
    <update-pass v-model="showUpdatePass" ref="updatePass"></update-pass>
  </div>
</template>

<script>
  import {ref} from 'vue';

  import UpdatePass from "./updatePass";
  import UpdateUserInfo from "./updateUserInfo";
  import UserAvatar from "../base/user-avatar";
  export default {
    name: "module",
    components: {UserAvatar, UpdatePass,UpdateUserInfo},
    computed: {
      user() {
        return this.$store.state.user;
      },
      noticeCount(){
        return this.$store.state.noticeCount
      }
    },
    mixins: [tableBase],
    data() {
      return {
        show:false,
        showUpdate:false,
        showUpdatePass:false,
        source:source,
        superToken:null,
      }
    },
    methods: {
      outLogin() {
        this.showConfirm("您确定退出吗?", () => {
          this.simplePost("/api/mgr/login/outLogin", null, () => {
            localStorage.removeItem("qc_super_token");
            localStorage.removeItem("activeIndex");
            localStorage.removeItem("qc_token");
            this.$store.commit('addUser','');
            this.$router.push({path: '/'});
          });
        });
      },
      toHelp(path){
          this.$store.commit("addIndex","9999");
          this.toRouter(path)
        /*this.$router.push({path:'/index/helpCenter'});*/
      },
      toBlank(path){
        let routeData = this.$router.resolve({path:path});
        window.open(routeData.href, '_blank');
      },
      moduleToRouter(path){
        localStorage.setItem('index',"9999");
        this.$store.commit("addIndex","9999");
        this.toRouter(path)
      },

    },
    mounted() {
        this.superToken = localStorage.getItem("qc_super_token");
    }
  }
</script>


<style lang="less" scoped>
.module{
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .tools-item{
    color: @message;
    margin-right: 35px;
    font-size: 16px;
    cursor: pointer;
    &:hover{
      color: @primary;
    }
  }
  .user-box{
    color: @message;
    font-size: 16px;
    cursor: pointer;
    position: relative;
    height: 60px;
    display: flex;
    align-items: center;
    .user-info{
      cursor: pointer;
      .user-info-menu{
        text-align: center;
        position: absolute;
        top: 60px;
        left: 0;
        width: 100%;
        z-index: 999;
        ul{
          padding: 0 0 20px 0;
          margin: 0;
          background-color: #FFFFFF;
          li{
            list-style: none;
            font-size: 14px;
            color: #000000;
            height: 30px;
            line-height: 30px;
            padding-top:5px;
            padding-bottom: 5px;
          }
          li:hover{
            background-color: @primary;
            color:#fff;
          }
        }
      }
    }
    .exit{
      margin-left: 11px;
      &:hover{
        color: @danger;
      }
    }
  }
  .message-box{
    margin-top: 5px;
    cursor: pointer;
    margin-right: 25px;
    &:hover{
      transform: scale(1.2);
    }
    i{
      color: @message;
      font-size: 20px;
    }
  }

  .gyl{
    color: #878787;
  }
}


</style>
